import type { EquipmentCreateDto, EquipmentDto, EquipmentUpdateDto, GetEquipmentsInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EquipmentService {
  apiName = 'Inventory';

  create = (input: EquipmentCreateDto) =>
    this.restService.request<any, EquipmentDto>({
      method: 'POST',
      url: `/api/inventory/equipments`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/equipments/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, EquipmentDto>({
      method: 'GET',
      url: `/api/inventory/equipments/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetEquipmentsInput) =>
    this.restService.request<any, PagedResultDto<EquipmentDto>>({
      method: 'GET',
      url: `/api/inventory/equipments`,
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: EquipmentUpdateDto) =>
    this.restService.request<any, EquipmentDto>({
      method: 'PUT',
      url: `/api/inventory/equipments/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
